import { values } from 'lodash';

import { DBDocSchema } from '../../../../generic/db-doc/db-doc-schema';
import { SchemaField } from '../../../../generic/serialization/schema-field';
import { OrgConfigName } from '../../org-config-name';

export class OrgConfigSchema extends DBDocSchema {
  ////////////////////////////////////////////////////////////////////////////////////////////////
  // Constants
  ////////////////////////////////////////////////////////////////////////////////////////////////

  public static readonly type = 'type';

  static Constants = class {
    public static readonly collection = 'orgConfig';
  };

  ////////////////////////////////////////////////////////////////////////////////////////////////
  // Defaults
  ////////////////////////////////////////////////////////////////////////////////////////////////

  static Defaults = class {
    public static readonly type: OrgConfigName | undefined = undefined;
  };

  public defaultValuesToSerialize(): Set<string> {
    return new Set([]);
  }

  ////////////////////////////////////////////////////////////////////////////////////////////////
  // Schema Parameters
  ////////////////////////////////////////////////////////////////////////////////////////////////

  public getSchemaDefinition(): { [key: string]: import('joi').AnySchema } {
    const parameters = super.getSchemaDefinition();
    parameters[OrgConfigSchema.type] = SchemaField.string(OrgConfigSchema.Defaults.type)
      .required()
      .valid(...values(OrgConfigName));
    return parameters;
  }

  ////////////////////////////////////////////////////////////////////////////////////////////////
  // Collection
  ////////////////////////////////////////////////////////////////////////////////////////////////

  public getCollection(orgId: string): string {
    return `${this.orgDoc(orgId)}/${OrgConfigSchema.Constants.collection}`;
  }
}
